import React from 'react';
import NewsletterForm from './NewsletterForm';
const NewsletterSection = () => {
  return <div className="relative bg-black" data-id="element-93">
      <div className="relative z-20 max-w-7xl mx-auto px-4 py-12 sm:py-20" data-id="element-94">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8" data-id="element-95">
          {/* Host Bio */}
          <div className="bg-gray-900/50 backdrop-blur-sm p-6 sm:p-8 rounded-2xl border border-gray-800/50" data-id="element-96">
            <div className="flex flex-col items-center text-center mb-4 sm:mb-6" data-id="element-97">
              <div className="w-24 h-24 sm:w-32 sm:h-32 rounded-full overflow-hidden mb-4 border-2 border-custom-green" data-id="element-98">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4nXcDgeMYBTqR188NdPKNr/headshot.png" alt="Ivan Acuna" className="w-full h-full object-cover" data-id="element-99" />
              </div>
              <h3 className="text-xl sm:text-2xl font-bold text-white mb-2 font-mono" data-id="element-100">
                IVAN ACUNA
              </h3>
              <p className="text-custom-green font-medium mb-4" data-id="element-101">Host</p>
            </div>
            <p className="text-white leading-relaxed text-sm sm:text-base" data-id="element-102">
              Ivan Acuna is the host of The Deal Flow Show and the Founder of
              The Cognitive Leverage Group, a firm dedicated to building brands
              for investment firms, family offices, and leaders in private
              equity. His experience in content strategy has helped generate
              billions of monthly organic impressions, and his firm now helping
              the world's most elite dealmakers.
            </p>
          </div>
          {/* Newsletter Section */}
          <div className="bg-gray-900/50 backdrop-blur-sm p-6 sm:p-8 rounded-2xl border border-gray-800/50" data-id="element-103">
            <div className="mb-6" data-id="element-104">
              <h3 className="text-2xl font-bold mb-2 text-white text-left font-mono" data-id="element-105">
                BRINGING THE WORLD OF PE TO THE INTERNET
              </h3>
              <p className="text-white text-left" data-id="element-106">
                Not only do we have the most real conversations in PE, we also
                have stories too good to share on social. That is why we created
                the Off-Market Memo.
                <br data-id="element-107" />
                <br data-id="element-108" />
                Every Tuesday we send out exclusive stories and insights from
                the top dealmakers around the world.
              </p>
            </div>
            <NewsletterForm data-id="element-109" />
          </div>
          {/* Co-Host Bio */}
          
        </div>
      </div>
    </div>;
};
export default NewsletterSection;